"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strings = void 0;
exports.strings = {
  prefixAgo: 'il y a',
  prefixFromNow: 'd\'ici',
  seconds: 'moins 1m',
  minute: 'environ 1m',
  minutes: 'environ %dm',
  hour: 'environ 1h',
  hours: 'environ %dh',
  day: 'environ 1j',
  days: 'environ %dj',
  month: 'environ 1m',
  months: 'environ %dm',
  year: '1a',
  years: '%da',
};
